import { render, staticRenderFns } from "./SearchFormCollapse.vue?vue&type=template&id=b3ae0234&scoped=true&"
import script from "./SearchFormCollapse.vue?vue&type=script&lang=js&"
export * from "./SearchFormCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SearchFormCollapse.vue?vue&type=style&index=0&id=b3ae0234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae0234",
  null
  
)

export default component.exports